export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-');
}

export function parseVin(vin: string): string {
  return vin.replace(/[^A-HJ-NPR-Z0-9]/gi, '').toUpperCase();
}

export function formatVin(vin: string): string {
  const clean = parseVin(vin);
  return clean.length === 17 ? clean : vin;
}

export { formatApproxSyncWindow } from './syndication-sync-schedule';
export {
  META_DESCRIPTION_MAX_LEN,
  validateMetaDescription,
  truncateMetaDescription,
} from './meta-description';
export type {
  MetaDescriptionWarning,
  MetaDescriptionError,
  MetaDescriptionWarningCode,
  MetaDescriptionErrorCode,
  MetaDescriptionValidationResult,
} from './meta-description';
export {
  buildVehicleTitle,
  buildFacebookVehicleTitle,
  buildFallbackDescription,
} from './vehicle-title';
export type { VehicleTitleParts, VehicleTitleWithMileage } from './vehicle-title';

